import Duck from "redux-ducks-ts"

export const customs = new Duck("customs", "cargo")
